<template>
  <div>

    <div class="courseCoordinators">
      <b-overlay :show="loadData" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <!-- Add Coordinator Button -->
        <b-button variant="primary" class="mb-2" size="sm" pill v-if="!createCoordinator"
          @click="createCoordinator = true">
          Add Event Co-ordinator
        </b-button>

        <!-- Add Coordinator Form -->
        <div v-if="createCoordinator">
          <AddCoordinator :eventModal="eventCoordinatorsModal" :faculties="faculties"
            :eventCoordinatorList="eventCoordinatorList" @addCoordinatorStatus="addCoordinatorStatus" />
        </div>

        <!-- Coordinator Table -->
        <table class="table table-striped table-bordered" v-else>
          <thead class="thead-dark text-left">
            <tr>
              <th>Sr. No.</th>
              <th>Name</th>
              <th>Remove</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(coordinator, coordinatorIndex) in eventCoordinatorList" :key="coordinator.pivot.id">
              <td>{{ coordinatorIndex + 1 }}</td>

              <td>
                {{ coordinator.first_name || "" }}
                {{ coordinator.last_name || "" }}
              </td>

              <td class="align-middle">
                <span class="text-danger btn m-0 p-0"
                  @click="deleteCoordinator(coordinator.pivot.id, coordinatorIndex)">
                  <i class="fas fa-trash"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import AddCoordinator from "./AddCoordinator.vue";

export default {
  props: ["eventCoordinatorsModal", "faculties"],

  components: { AddCoordinator },

  data() {
    return {
      eventCoordinatorList: [],
      loadData: false,
      createCoordinator: false,
    };
  },

  created() {
    this.fetchEventCoordinatorList();
  },

  methods: {
    // Load existing coordinators
    fetchEventCoordinatorList() {
      if (!this.eventCoordinatorsModal.coordinators) return;

      this.eventCoordinatorList = [...this.eventCoordinatorsModal.coordinators];

      // sort A–Z
      this.eventCoordinatorList.sort((a, b) =>
        (a.first_name || "").localeCompare(b.first_name || "")
      );
    },

    async fetchEventCoordinators() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/eventcoordinators`;

      await this.$axios
        .get(url, {
          params: { event_id: this.eventCoordinatorsModal.id }
        })
        .then((res) => {
          if (res.data && res.data.faculties) {
            this.eventCoordinatorList = [...res.data.faculties];

            // Sort A–Z
            this.eventCoordinatorList.sort((a, b) =>
              (a.first_name || "").localeCompare(b.first_name || "")
            );
          } else {
            this.eventCoordinatorList = [];
          }
        })
        .catch((err) => {
          console.error(err);
          this.eventCoordinatorList = [];
        });
    },

    // After adding coordinator
    addCoordinatorStatus(status) {
      if (status) {
        this.createCoordinator = false;
        console.log("enter");
        this.fetchEventCoordinators();

        // refresh latest from parent
        this.$emit("newEventCoordinatorAdded");

      } else {
        this.createCoordinator = false;
      }
    },

    // Delete & remove immediately from table
    deleteCoordinator(pivotId, index) {
      this.loadData = true;

      let baseUrl = this.$store.getters.getAPIKey.deleteEventCoordinator;
      let url = baseUrl.replace("event_coordinator_id", pivotId);

      this.$axios
        .delete(url)
        .then(() => {
          this.$toast.success("Coordinator removed successfully!", {
            position: "top",
            duration: 3000,
          });

          // remove instantly from UI
          this.eventCoordinatorList.splice(index, 1);

          this.$emit("coordinatorsRemove", this.eventCoordinatorList.length);

          this.loadData = false;
        })
        .catch(() => {
          this.$toast.error("Something went wrong, please try again!", {
            position: "top",
            duration: 3000,
          });
          this.loadData = false;
        });
    },
  },
};
</script>
